export const dateMask = [/\d/, /\d/, "/", /\d/, /\d/, "/", /[1-2]/, /\d/, /\d/, /\d/];
